const SEARCH = {
    onReady() {
        document.addEventListener('click', SEARCH.filterClick);
    },
    /*********************
    * Must be handled over a document event listener because of xhr reloads
    *********************/
    filterClick() {
        let dropdown = event.target.closest('.dropdown');
        if (dropdown === null) return;
        let filter = dropdown.closest('#filter');
        if (filter === null) return;
        if (!event.target.classList.contains('dropdown__item')) return;
        event.preventDefault();      
        XHR.load({
            nodeIds: ['filter', 'search-subscribe'],
            url: event.target.href,
            functionCall: [ MAIN.onReady ]
        });
        window.history.replaceState(null, '', event.target.href);
        return;
    }
}